import { render, staticRenderFns } from "./BeepTestStats.vue?vue&type=template&id=7c08fd7e&"
import script from "./BeepTestStats.vue?vue&type=script&lang=js&"
export * from "./BeepTestStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports